import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Card, BUTTON_VARIANT, H3, H2 } from '@manulife/mux';
import { afterThreeTries } from 'components/VerifyPassword/actions';
import styled from 'styled-components';
import {
  FormattedRichMessage,
  useRichIntl,
  useRealm,
  usePathBuilder,
  useCIAMContextParam,
  ContentPage,
  customStyles,
  CIAMLinkButton,
} from 'ciam-self-service-shared';
import initAsyncAction from 'utils/loginAuthnTree/initAsyncActionImpl';
import { Redirect } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Page, { AUTH_TYPE } from '../../common/Page';
import { AUTH_TREE_REALM_MAPPING } from '../constants';
import useUniversalLink from '../../../hooks/useUniversalLink';
import { MainContainer, IntroductionPageCardWrapper } from './styledComponents';
import useOnDemandOtpRedirect from '../../OnDemandOTP/useOnDemandOtpRedirect';

const CardWrapper = styled(Card)`
  height: 300px;
  width: 100%;
  max-width: 350px;
  padding: 1rem;
`;

const ButtonWrapper = styled.div`
  padding: 0 20px 20px 20px;
`;

function IntroductionPage() {
  const realm = useRealm();
  const dispatch = useDispatch();
  const universalLink = useUniversalLink();
  const richIntl = useRichIntl();
  const pathBuilder = usePathBuilder();
  const brand = useCIAMContextParam('brand');
  const mainBackButtonFlag = sessionStorage.getItem('ciam.backButton-otp');
  const addNumberBackButtonFlag = sessionStorage.getItem('ciam.addNumberbackButton-otp');
  const addBackupEmailbackButtonFlag = sessionStorage.getItem('ciam.addBackupEmailbackButton-otp');
  const isOnDemand = useOnDemandOtpRedirect();

  useEffect(() => {
    if (!mainBackButtonFlag && !addNumberBackButtonFlag && !addBackupEmailbackButtonFlag && !isOnDemand) {
      initAsyncAction(dispatch, AUTH_TREE_REALM_MAPPING[realm], realm, brand);
      dispatch(afterThreeTries());
    }
  }, [mainBackButtonFlag, addNumberBackButtonFlag, addBackupEmailbackButtonFlag, realm, brand, dispatch, isOnDemand]);

  if (universalLink) {
    window.location.href = universalLink;
    return null;
  }

  if (mainBackButtonFlag) {
    return <Redirect to={pathBuilder('/otp')} />;
  }
  if (addNumberBackButtonFlag) {
    return <Redirect to={pathBuilder('/addnumbermfa')} />;
  }

  if (isOnDemand) {
    return null;
  }

  return (
    <Page
      title={richIntl.formatMessage({ id: 'introduction.page.title' })}
      authType={AUTH_TYPE.UNAUTHENTICATED}
      heading={richIntl.formatMessage({ id: 'introduction.page.heading' })}
    >
      <ContentPage
        title={richIntl.formatMessage({ id: 'introduction.page.title' })}
        heading={<FormattedRichMessage id="introduction.page.heading" />}
        contentColumns={9}
      >
        <H2>
          <FormattedRichMessage id="introduction.page.subheading" />
        </H2>
        <FormattedRichMessage id="introduction.page.inboundManulifeId.para" />
        <MainContainer>
          <IntroductionPageCardWrapper>
            <CardWrapper>
              <Card.Content>
                <H3>
                  <FormattedRichMessage id="introduction.page.haveid" />
                </H3>
                <p>
                  <FormattedRichMessage id="introduction.page.haveidbeginjourney" />
                </p>
              </Card.Content>
              <ButtonWrapper>
                <CIAMLinkButton
                  to="/"
                  customStyle={customStyles.signInButton}
                  analyticsData={{
                    click: {
                      linkName: richIntl.formatMessage({ id: 'common.signin' }),
                      linkHref: '/',
                    },
                  }}
                >
                  <FormattedMessage id="common.signin" />
                </CIAMLinkButton>
              </ButtonWrapper>
            </CardWrapper>
            <CardWrapper>
              <Card.Content>
                <H3>
                  <FormattedRichMessage id="introduction.page.donthaveid" />
                </H3>
                <p>
                  <FormattedRichMessage id="introduction.page.idadvantages" />
                </p>
              </Card.Content>
              <ButtonWrapper>
                <CIAMLinkButton
                  to="/register"
                  variant={BUTTON_VARIANT.SECONDARY}
                  customStyle={customStyles.button}
                  analyticsData={{
                    click: {
                      linkName: richIntl.formatMessage({ id: 'aboutmanulifeid.page.gosignup.button' }),
                      linkHref: '/register',
                    },
                  }}
                >
                  <FormattedRichMessage id="aboutmanulifeid.page.gosignup.button" />
                </CIAMLinkButton>
              </ButtonWrapper>
            </CardWrapper>
          </IntroductionPageCardWrapper>
        </MainContainer>
      </ContentPage>
    </Page>
  );
}

export default IntroductionPage;
